import React, { useState } from 'react';
import Header from './Header';

const Layout = ({ children }) => {
  const [isExpanded, setIsExpanded] = useState(false);

  return (
    <div className={`app${isExpanded ? ' sidebar-expanded' : ''}`}>
      <Header isExpanded={isExpanded} setIsExpanded={setIsExpanded} />
      <main className="main-content">
        {children}
      </main>
    </div>
  );
};

export default Layout; 